import React, { useState } from "react";
import "../css/sobtargetuploadstockist.css";
import { BASE_URL } from "../config";
import axios from "axios";
import { getAuthHeaders } from "../services/useAuth";
import CustomButton from "./CustomButton";

const SOBTargetUpload = () => {
  const [file, setFile] = useState(null);
  const [uploadStatus, setUploadStatus] = useState(null); // changed to null
  const [uploadError, setUploadError] = useState("");

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFile(file);
    setUploadStatus(null);
    setUploadError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      setUploadError("Please select a file");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      setUploadStatus({ loading: true });
      const response = await axios.post(
        `${BASE_URL}/api/sob-targets/bulk-upload`,
        formData,
        {
          headers: {
            ...getAuthHeaders(),
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // ✅ Store the full response data
      setUploadStatus({
        loading: false,
        message: response.data.message,
        inserted: response.data.inserted,
        updated: response.data.updated,
        skipped: response.data.skipped,
        skip_reasons: response.data.skip_reasons || [],
      });
      setUploadError("");
    } catch (err) {
      const resData = err.response?.data;
      let message = "Upload failed.";
      if (resData?.detail) {
        if (typeof resData.detail === "string") {
          message = resData.detail;
        } else if (resData.detail.includes?.("required columns")) {
          const columns = resData.detail.split(":")[1].trim().split(", ");
          message = `File is missing required columns: ${columns.join(", ")}`;
        }
      }
      setUploadStatus(null);
      setUploadError(message);
    }
  };

  return (
    <div className="sobtarget-main-container">
      <div className="sobtarget-select-container">
        <h1 className="text-xl sm:text-2xl font-bold text-center text-gray-800 mb-4">
          <span className="text-blue-700"> Select </span>
          <span className="text-blue-500">File</span>
        </h1>

        <form onSubmit={handleSubmit}>
          <div className="sobtarget-form-row">
            <label htmlFor="sobTargetFile" className="sobtarget-label">
              SOB Target File
            </label>
            <input
              type="file"
              id="sobTargetFile"
              onChange={handleFileChange}
              className="sobtarget-input"
            />
            <CustomButton label="Go" type="submit" variant="go" />
          </div>
        </form>

        {/* ✅ Loading state */}
        {uploadStatus?.loading && (
          <p className="text-blue-500 mt-3 text-sm">Uploading...</p>
        )}

        {/* ✅ Error message */}
        {uploadError && (
          <p className="text-red-500 mt-3 text-sm font-medium">{uploadError}</p>
        )}

        {/* ✅ Success result card */}
        {uploadStatus && !uploadStatus.loading && (
          <div className="mt-4 p-4 border border-green-300 bg-green-50 rounded-lg">
            {/* Dynamic message from API */}
            <p className="text-green-700 font-semibold text-base mb-3">
              ✅ {uploadStatus.message}
            </p>

            {/* Summary counts */}
            <div className="flex gap-4 mb-3">
              <span className="px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-sm font-medium">
                Inserted: {uploadStatus.inserted}
              </span>
              <span className="px-3 py-1 bg-green-100 text-green-700 rounded-full text-sm font-medium">
                Updated: {uploadStatus.updated}
              </span>
              <span className="px-3 py-1 bg-yellow-100 text-yellow-700 rounded-full text-sm font-medium">
                Skipped: {uploadStatus.skipped}
              </span>
            </div>

            {/* Skip reasons table */}
            {uploadStatus.skip_reasons.length > 0 && (
              <div>
                <p className="text-yellow-700 font-medium text-sm mb-2">
                  ⚠️ Skipped Records ({uploadStatus.skip_reasons.length}):
                </p>
                <div className="overflow-x-auto">
                  <table className="w-full text-sm border border-gray-200 rounded">
                    <thead className="bg-yellow-100 text-yellow-800">
                      <tr>
                        <th className="px-3 py-2 text-left">#</th>
                        <th className="px-3 py-2 text-left">Employee ID</th>
                          <th className="px-3 py-2 text-left">Employee Name</th>
                        <th className="px-3 py-2 text-left">Stockist Code</th>
                          <th className="px-3 py-2 text-left">Stockist Name</th>
                        <th className="px-3 py-2 text-left">Reason</th>
                      </tr>
                    </thead>
                    <tbody>
                      {uploadStatus.skip_reasons.map((item, index) => (
                        <tr
                          key={index}
                          className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}
                        >
                          <td className="px-3 py-2 text-gray-500">{index + 1}</td>
                          <td className="px-3 py-2">{item.employee_id}</td>
                          <td className="px-3 py-2">{item.employee_name || "-"}</td>
                          <td className="px-3 py-2">{item.stockist_code}</td>
                          <td className="px-3 py-2">{item.stockist_name || "-"}</td>
                          <td className="px-3 py-2 text-red-500">{item.reason}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default SOBTargetUpload;